(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iteraq-intelligence-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sources = {
    GB: {business:'https://www.gov.uk/set-up-business',tax:'https://www.gov.uk/browse/business/business-tax'},
    US: {business:'https://www.sba.gov/business-guide/launch-your-business',tax:'https://www.irs.gov/businesses'},
    SE: {business:'https://verksamt.se/en',tax:'https://www.skatteverket.se/servicelankar/otherlanguages/inenglish.4.12815e4f14a62bc048f4edc.html'},
    DE: {business:'https://www.gtai.de/en/invest/investment-guide',tax:'https://www.bzst.de/EN/Home/home_node.html'},
    TR: {business:'https://www.invest.gov.tr/en/investmentguide/pages/establishing-a-business.aspx',tax:'https://www.gib.gov.tr/'},
    AZ: {business:'https://smb.gov.az/en',tax:'https://www.taxes.gov.az/en'},
    AE: {business:'https://u.ae/en/information-and-services/business',tax:'https://tax.gov.ae/en/'},
    SG: {business:'https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company',tax:'https://www.iras.gov.sg/'},
    CA: {business:'https://www.canada.ca/en/services/business/start.html',tax:'https://www.canada.ca/en/revenue-agency/services/tax/businesses.html'},
    AU: {business:'https://business.gov.au/guide/starting',tax:'https://www.ato.gov.au/businesses-and-organisations'}
  };
  const ids = ['NY.GDP.MKTP.CD','SP.POP.TOTL','NY.GDP.MKTP.KD.ZG','FP.CPI.TOTL.ZG'];
  function initialise(root) {
    if (root.dataset.iqReady) return;
    root.dataset.iqReady = 'true';
    let controller, sequence = 0;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let tickerPaused = reducedMotion.matches;
    const clockNodes = [...root.querySelectorAll('[data-iq-clock]')];
    const clockFormats = clockNodes.map(node => new Intl.DateTimeFormat('en-GB',{timeZone:node.dataset.iqClock,hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}));
    function updateClocks() {
      const now = new Date();
      root.querySelector('[data-iq-date]').textContent = new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',day:'2-digit',month:'short',year:'numeric'}).format(now) + ' · UTC';
      clockNodes.forEach((node,index) => {
        node.textContent = clockFormats[index].format(now);
        node.dateTime = now.toISOString();
        node.title = node.dataset.iqClock + ' · ' + new Intl.DateTimeFormat('en-GB',{timeZone:node.dataset.iqClock,dateStyle:'medium'}).format(now);
      });
    }
    updateClocks();
    const clockInterval = setInterval(() => {
      if (!root.isConnected) {clearInterval(clockInterval);return;}
      if (!document.hidden) updateClocks();
    },1000);
    const cache = new Map();
    const select = root.querySelector('[data-iq-country]');
    const status = root.querySelector('[data-iq-country-status]');
    const formatNumber = (n) => new Intl.NumberFormat('en-GB',{maximumFractionDigits:2}).format(n);
    const compact = (n) => new Intl.NumberFormat('en-GB',{notation:'compact',maximumFractionDigits:2}).format(n);
    function clearIndicators(message) {
      ids.forEach(id => {
        root.querySelector(`[data-iq-value="${id}"]`).textContent = '—';
        root.querySelector(`[data-iq-year="${id}"]`).textContent = message;
      });
    }
    async function country() {
      const current = ++sequence;
      controller?.abort();
      controller = new AbortController();
      const code = select.value;
      if (!sources[code]) return;
      root.querySelector('[data-iq-country-title]').textContent = select.options[select.selectedIndex].text;
      root.querySelector('[data-iq-business]').href = sources[code].business;
      root.querySelector('[data-iq-tax]').href = sources[code].tax;
      root.querySelector('[data-iq-economy]').href = `https://data.worldbank.org/country/${code}`;
      clearIndicators('Loading annual data…');
      status.textContent = 'Loading official annual observations from the World Bank…';
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(),20000);
      try {
        let data = cache.get(code);
        if (!data || Date.now() - data.checked > 3600000) {
          const year = new Date().getUTCFullYear();
          const url = `https://api.worldbank.org/v2/country/${code}/indicator/${ids.join(';')}?source=2&format=json&per_page=120&date=${year-8}:${year}`;
          const response = await fetch(url,{signal:controller.signal,credentials:'omit'});
          if (!response.ok) throw new Error('Source unavailable');
          const body = await response.json();
          if (!Array.isArray(body?.[1])) throw new Error('No observations');
          data = {meta:body[0],rows:body[1],checked:Date.now()};
          cache.set(code,data);
        }
        if (current !== sequence || !root.isConnected) return;
        let shown = 0;
        ids.forEach((id,index) => {
          const row = data.rows.filter(r => r.indicator?.id === id && typeof r.value === 'number' && Number.isFinite(r.value)).sort((a,b)=>Number(b.date)-Number(a.date))[0];
          const value = root.querySelector(`[data-iq-value="${id}"]`);
          const year = root.querySelector(`[data-iq-year="${id}"]`);
          if (!row) {value.textContent='—';year.textContent='No published observation';return;}
          shown++;
          value.textContent = index === 0 ? `US$${compact(row.value)}` : index === 1 ? compact(row.value) : `${formatNumber(row.value)}%`;
          year.textContent = `${row.date} · ${index === 0 ? 'GDP, current US$' : index === 1 ? 'People' : index === 2 ? 'Annual real GDP growth' : 'Annual CPI change'}`;
        });
        const checked = new Date(data.checked).toISOString().replace('T',' ').slice(0,16);
        status.textContent = shown ? `Source: World Bank, World Development Indicators · Dataset updated ${data.meta.lastupdated || 'date not supplied'} · Retrieved ${checked} UTC. Each figure shows its observation year.` : 'No published observations available for this selection. Open the official country sources below.';
      } catch (error) {
        if (current !== sequence || !root.isConnected) return;
        clearIndicators('Data unavailable');
        status.textContent = 'The World Bank data feed is temporarily unavailable. Open the official country sources below, or select another country to retry.';
      } finally {clearTimeout(timeout);}
    }
    select.addEventListener('change',country);
    const observer = new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)){observer.disconnect();country();}
    },{rootMargin:'350px'});
    observer.observe(root.querySelector('#global'));
    function widget(kind) {
      if(!window.iteraqPrivacy?.analyticsAllowed())return;
      const holder = root.querySelector(`[data-iq-widget="${kind}"]`);
      if (!holder || holder.dataset.loaded) return;
      holder.dataset.loaded = 'true';
      const target = holder.querySelector('.tradingview-widget-container');
      const label = root.querySelector(kind === 'tickers' ? '[data-iq-ticker-status]' : '[data-iq-news-status]');
      const script = document.createElement('script');
      script.async = true;
      const widgetType = kind === 'tickers' && !tickerPaused ? 'ticker-tape' : kind;
      script.src = `https://s3.tradingview.com/external-embedding/embed-widget-${widgetType}.js`;
      const config = kind === 'tickers' ? {
        symbols:[{proName:'BITSTAMP:BTCUSD',title:'BTC / USD'},{proName:'BITSTAMP:ETHUSD',title:'ETH / USD'},{proName:'OANDA:XAUUSD',title:'GOLD / USD'},{proName:'FX:GBPUSD',title:'GBP / USD'},{proName:'FX:EURUSD',title:'EUR / USD'}],
        colorTheme:'light',isTransparent:true,showSymbolLogo:true,displayMode:'regular',locale:'en'
      } : {feedMode:'all_symbols',colorTheme:'light',isTransparent:true,displayMode:'regular',width:'100%',height:440,locale:'en'};
      script.textContent = JSON.stringify(config);
      const timeout = setTimeout(()=>{if(!holder.querySelector('iframe')) {label.hidden=false;label.textContent='The feed is taking longer to connect. Open the TradingView source link for the latest information.';}},15000);
      script.addEventListener('error',()=>{clearTimeout(timeout);label.hidden=false;label.textContent = 'Feed unavailable. Open the TradingView source link for the latest information.';});
      script.addEventListener('load',()=>{
        clearTimeout(timeout);
        const frame = holder.querySelector('iframe');
        label.hidden=Boolean(frame);
        if(frame) frame.title=kind==='tickers'?'Market prices from TradingView':'Business and economy news from TradingView';
      });
      target.appendChild(script);
    }
    function renderTicker() {
      const holder = root.querySelector('[data-iq-widget="tickers"]');
      const container = holder.querySelector('.tradingview-widget-container');
      container.querySelectorAll('iframe,script,.tradingview-widget-container__widget').forEach(node=>node.remove());
      const slot=document.createElement('div');
      slot.className='tradingview-widget-container__widget';
      container.prepend(slot);
      delete holder.dataset.loaded;
      root.querySelector('.iq-ticker-scroll').classList.toggle('iq-ticker-paused',tickerPaused);
      const button = root.querySelector('[data-iq-motion]');
      button.textContent = tickerPaused ? 'Play ticker' : 'Pause ticker';
      button.setAttribute('aria-pressed',String(tickerPaused));
      widget('tickers');
    }
    root.querySelector('[data-iq-motion]').addEventListener('click',()=>{tickerPaused=!tickerPaused;renderTicker();});
    const motionChange=()=>{if(root.isConnected){tickerPaused=reducedMotion.matches;renderTicker();}};
    reducedMotion.addEventListener('change',motionChange);
    window.iteraqPrivacy?.whenAnalytics(renderTicker);
    window.iteraqPrivacy?.whenAnalytics(()=>widget('timeline'));
    const liveWidgetConfigs = {
      'screener': {src:'https://s3.tradingview.com/external-embedding/embed-widget-screener.js',config:{width:'100%',height:'100%',defaultColumn:'overview',screener_type:'crypto_mkt',displayCurrency:'USD',colorTheme:'light',locale:'en',isTransparent:true}},
      'advanced-chart': {src:'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js',config:{autosize:true,symbol:'BITSTAMP:BTCUSD',interval:'60',timezone:'Etc/UTC',theme:'light',style:'1',locale:'en',allow_symbol_change:true,calendar:false,hide_side_toolbar:true,support_host:'https://www.tradingview.com'}},
      'timeline': {src:'https://s3.tradingview.com/external-embedding/embed-widget-timeline.js',config:{feedMode:'all_symbols',colorTheme:'light',isTransparent:true,displayMode:'regular',width:'100%',height:'100%',locale:'en'}},
      'events': {src:'https://s3.tradingview.com/external-embedding/embed-widget-events.js',config:{colorTheme:'light',isTransparent:true,width:'100%',height:'100%',locale:'en',importanceFilter:'0,1',countryFilter:'us,gb,eu,de,se,tr'}},
      'market-overview': {src:'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js',config:{colorTheme:'light',dateRange:'1D',showChart:true,locale:'en',width:'100%',height:'100%',isTransparent:true,showSymbolLogo:true,tabs:[{title:'Indices',symbols:[{s:'FOREXCOM:SPXUSD',d:'S&P 500'},{s:'NASDAQ:NDX',d:'NASDAQ 100'},{s:'DJ:DJI',d:'Dow Jones'},{s:'XETR:DAX',d:'DAX'},{s:'FOREXCOM:UKXGBP',d:'FTSE 100'}]},{title:'Forex',symbols:[{s:'FX:EURUSD'},{s:'FX:GBPUSD'},{s:'FX:USDJPY'},{s:'FX:USDCHF'}]},{title:'Commodities',symbols:[{s:'OANDA:XAUUSD',d:'Gold'},{s:'TVC:USOIL',d:'Crude Oil'},{s:'OANDA:XAGUSD',d:'Silver'}]}]}}
    };
    window.iteraqPrivacy?.whenAnalytics(()=>root.querySelectorAll('[data-iq-live-widget]').forEach(holder=>{
      const setup=liveWidgetConfigs[holder.dataset.iqLiveWidget];
      const target=holder.querySelector('.tradingview-widget-container');
      if(!setup||!target||holder.dataset.loaded)return;
      holder.dataset.loaded='true';
      const script=document.createElement('script');
      script.async=true;
      script.src=setup.src;
      script.textContent=JSON.stringify(setup.config);
      target.appendChild(script);
    }));
    function loadBitcoinChart() {
      const holder = root.querySelector('[data-iq-bitcoin-chart]');
      const status = root.querySelector('[data-iq-bitcoin-status]');
      if (!holder || holder.dataset.loaded) return;
      holder.dataset.loaded = 'true';
      const target = holder.querySelector('.tradingview-widget-container');
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
      script.textContent = JSON.stringify({
        autosize:true,
        symbol:'BITSTAMP:BTCUSD',
        interval:'60',
        timezone:'Etc/UTC',
        theme:'light',
        style:'1',
        locale:'en',
        allow_symbol_change:false,
        calendar:false,
        hide_side_toolbar:true,
        support_host:'https://www.tradingview.com'
      });
      const timeout = setTimeout(()=>{
        if (!holder.querySelector('iframe')) {
          status.hidden = false;
          status.textContent = 'Live chart is taking longer to connect. Open the TradingView source link.';
        }
      },15000);
      script.addEventListener('error',()=>{
        clearTimeout(timeout);
        status.hidden = false;
        status.textContent = 'Live chart unavailable. Open the TradingView source link.';
      });
      script.addEventListener('load',()=>{
        clearTimeout(timeout);
        const frame = holder.querySelector('iframe');
        status.hidden = Boolean(frame);
        if (frame) frame.title = 'Live Bitcoin price chart from TradingView';
      });
      target.appendChild(script);
    }
    window.iteraqPrivacy?.whenAnalytics(loadBitcoinChart);
    const newsRefresh = setInterval(() => {
      if (!root.isConnected) {clearInterval(newsRefresh);reducedMotion.removeEventListener('change',motionChange);controller?.abort();return;}
      if (document.hidden) return;
      const frame = root.querySelector('[data-iq-widget="timeline"] iframe');
      if (frame && document.activeElement !== frame) {
        frame.src = frame.src;
        root.querySelector('[data-iq-news-refresh]').textContent = 'Feed requested at ' + new Date().toISOString().slice(11,16) + ' UTC · Refreshes every five minutes.';
      }
    },300000);
    root.querySelector('[data-iq-calc]').addEventListener('submit',event=>{
      event.preventDefault();
      const form = event.currentTarget;
      const values = ['units','price','variable','fixed'].map(name=>Number(form.elements[name].value));
      const result = root.querySelector('[data-iq-calc-result]');
      if (!form.checkValidity() || values.some(n=>!Number.isFinite(n)||n<0)) {result.textContent='Enter valid non-negative values in every field.';return;}
      const [units,price,variable,fixed] = values;
      const revenue = units*price, contribution = units*(price-variable)-fixed;
      if (!Number.isFinite(revenue) || !Number.isFinite(contribution)) {result.textContent='These inputs are too large to calculate. Please check your figures.';return;}
      const breakeven = price>variable ? `${formatNumber(Math.ceil(fixed/(price-variable)))} units per month` : fixed===0 && price===variable ? 'zero contribution at every volume' : 'not achievable with these unit economics';
      result.textContent = `Monthly revenue: ${formatNumber(revenue)} · Operating contribution: ${formatNumber(contribution)} · Break-even: ${breakeven}. Values use your input currency.`;
    });
    root.querySelectorAll('.iq-mobile a').forEach(link=>link.addEventListener('click',()=>root.querySelector('.iq-mobile').removeAttribute('open')));
    root.querySelector('a[href="#calculator"]').addEventListener('click',()=>root.querySelector('#calculator').setAttribute('open',''));
  }
  function start(){document.querySelectorAll('[data-iq-home]').forEach(initialise);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iteraq-project-builder"] && !Shopify.designMode) return;
  try {
    

(() => {
 const init = root => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = "true";
  const form = root.querySelector("form");
  if (!form) return;
  const copy = Object.fromEntries(Array.from(root.querySelectorAll("[data-copy]"), n => [n.dataset.copy, n.textContent]));
  const el = k => form.querySelector('[data-field="' + k + '"]');
  if (!el("kind")) { root.querySelector(".itq-builder-success")?.focus(); return; }
  const val = k => el(k)?.value?.trim() || "";
  const selected = k => el(k)?.selectedOptions?.[0]?.textContent || val(k);
  const status = root.querySelector("[data-planner-status]");
  const result = root.querySelector("[data-result]");
  const content = root.querySelector("[data-result-content]");
  let brief = "";
  let generatedAt = "";
  const clean = x => String(x || "").replace(/[\u0000-\u001F\u007F]/g, " ").slice(0,120);
  const params = new URLSearchParams(window.location.search);
  el("source").value = clean(params.get("source"));
  el("service").value = clean(params.get("service"));
  const kind = params.get("kind");
  if (["project","support","complaint"].includes(kind)) el("kind").value = kind;
  const referred = {"mobile-apps":"mobile","online-stores":"store","amazon-selling":"store","dropshipping":"store","ai-assistants":"ai","business-plans":"advice","automation-integrations":"saas","data-dashboards":"saas","custom-software":"saas"};
  if (referred[val("service")]) el("type").value = referred[val("service")];
  const projectControls = root.querySelector("[data-planner-controls]");
  const sync = () => {
   const project = val("kind") === "project";
   el("type").required = project;
   el("country-other").required = val("country") === "other";
   el("country-other").closest(".itq-builder-field").hidden = val("country") !== "other";
   projectControls.hidden = !project;
  };
  const invalidate = event => {
   sync();
   if (!["name","email","company","phone"].includes(event?.target?.dataset?.field) && brief) {
    brief = ""; el("brief").value = ""; result.hidden = true; status.textContent = copy.stale;
   }
  };
  form.addEventListener("input", invalidate);
  form.addEventListener("change", invalidate);
  sync();
  const line = (label,value) => label + ": " + (value || "—");
  const build = () => {
   for (const key of ["type","country","country-other","requirements","size","website-url"]) {
    const field = el(key); if (field && !field.checkValidity()) { field.reportValidity(); return; }
   }
   if (val("kind") !== "project") return;
   const chosen = val("type");
   const category = {website:"web",store:"store",mobile:"mobile",saas:"saas",marketplace:"market",ai:"ai",advice:"advice"}[chosen];
   if (!category) return;
   const features = [];
   if (val("payment") === "yes" || chosen === "store") features.push(copy.feature_payment);
   if (val("booking") === "yes") features.push(copy.feature_booking);
   if (val("languages")) features.push(copy.feature_language);
   if (["ios","android","both"].includes(val("app")) && chosen !== "mobile") features.push(copy.feature_mobile);
   const country = val("country") === "other" ? val("country-other") : val("country");
   const lines = [
    copy.brand + " — " + copy.download_title, copy.download_note, "",
    copy.result_solution + ": " + copy["suggest_" + category], copy["scope_" + category], "",
    line(copy.country,country), line(copy.industry,val("industry")), line(copy.stage,selected("stage")),
    line(copy.audience,val("audience")), line(copy.size,val("size")), line(copy.languages,val("languages")),
    line(copy.payment,selected("payment")), line(copy.booking,selected("booking")), line(copy.app,selected("app")),
    line(copy.budget,selected("budget") + " " + val("currency")), line(copy.deadline,val("deadline")),
    line(copy.automation,val("automation")), line(copy.application,val("application")),
    line(copy.domain,val("domain")), line(copy.website_url,val("website-url")), "",
    copy.requirements + ":", val("requirements"), "",
    copy.result_features + ":", ...features.map(x => "• " + x), "",
    copy.result_checks + ":", "• " + copy.check_base, "• " + copy.check_budget, "• " + copy.check_country,
    ...(val("deadline") ? ["• " + copy.check_deadline] : []), "", copy.result_next + ":", copy.next
   ];
   if (val("source")) lines.push("",line(copy.source_label,val("source")));
   if (val("service")) lines.push(line(copy.service_label,val("service")));
   brief = lines.join("\n");
   generatedAt = new Date().toISOString().slice(0,10);
   el("brief").value = brief;
   content.textContent = brief;
   result.hidden = false;
   result.focus();
   status.textContent = copy.ready;
   return true;
  };
  const panels = Array.from(form.querySelectorAll('[data-project-step]'));
  const progress = form.querySelector('[data-step-progress]');
  const actions = form.querySelector('[data-step-actions]');
  const back = form.querySelector('[data-step-back]');
  const next = form.querySelector('[data-step-next]');
  let current = 1;
  const show = step => {
   current = step;
   panels.forEach(p => { p.hidden = Number(p.dataset.projectStep) !== step; });
   progress.textContent = copy['step' + step];
   back.hidden = step === 1;
   back.textContent = step === 3 ? copy.edit : copy.back;
   next.hidden = step === 4;
   if (step === 1 || step === 2) projectControls.hidden = true;
   const panel = panels.find(p => Number(p.dataset.projectStep) === step);
   panel.setAttribute('tabindex', '-1');
   panel.focus({preventScroll:true});
  };
  const validate = step => {
   const panel = panels.find(p => Number(p.dataset.projectStep) === step);
   const invalid = Array.from(panel.querySelectorAll('input,select,textarea')).find(f => !f.checkValidity());
   if (invalid) { show(step); invalid.reportValidity(); return false; }
   return true;
  };
  next.addEventListener('click', () => {
   if (current === 1 && validate(1)) show(2);
   else if (current === 2 && validate(2)) {
    if (val('kind') !== 'project') show(4);
    else if (build()) show(3);
   } else if (current === 3) show(4);
  });
  back.addEventListener('click', () => show(current === 4 && val('kind') !== 'project' ? 2 : current - 1));
  form.noValidate = true;
  form.addEventListener('submit', event => {
   if (current !== 4) { event.preventDefault(); next.click(); return; }
   if (![1,2,4].every(validate)) { event.preventDefault(); return; }
   if (val('kind') === 'project' && !build()) { event.preventDefault(); return; }
   show(4);
  });
  progress.hidden = false;
  actions.hidden = false;
  show(1);
  form.addEventListener('change', () => { projectControls.hidden = true; });
  form.addEventListener('input', () => { projectControls.hidden = true; });
  root.querySelector("[data-generate]").addEventListener("click", () => { if(build()) show(3); });
  const escape = s => String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  root.querySelector("[data-download]").addEventListener("click", () => {
   if (!brief) return;
   const logo = root.querySelector(".itq-builder-logo").src;
   const doc = '<!doctype html><html lang="en"><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' + escape(copy.download_title) + '</title><style>body{max-width:820px;margin:40px auto;padding:24px;font:16px/1.65 Arial;color:#102d35}img{width:110px;height:auto}pre{font:inherit;white-space:pre-wrap;overflow-wrap:anywhere}h1{line-height:1.15}</style><img src="' + escape(logo) + '" alt="ITERAQ"><h1>' + escape(copy.download_title) + '</h1><p>' + escape(copy.created) + ': ' + generatedAt + '</p><pre>' + escape(brief) + '</pre></html>';
   const url = URL.createObjectURL(new Blob([doc],{type:"text/html;charset=utf-8"}));
   const a = document.createElement("a"); a.href=url; a.download="ITERAQ-project-brief.html"; document.body.append(a); a.click(); a.remove();
   setTimeout(() => URL.revokeObjectURL(url),1000);
   status.textContent=copy.download_ready;
  });
  root.querySelector("[data-print]").addEventListener("click", () => { if (brief) window.print(); });
 };
 const start = () => document.querySelectorAll("[data-iteraq-builder]").forEach(init);
 if (document.readyState === "loading") document.addEventListener("DOMContentLoaded",start); else start();
 document.addEventListener("shopify:section:load",start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
